import { Entity } from "src/app/core/utils/entity";

export abstract class DeleteUserEntity extends Entity {
    constructor(
        public id: string
    ) {
        super();
    }
}
